import { render, staticRenderFns } from "./Index-Sale.vue?vue&type=template&id=63471c30&scoped=true&"
import script from "./Index-Sale.vue?vue&type=script&lang=js&"
export * from "./Index-Sale.vue?vue&type=script&lang=js&"
import style0 from "./Index-Sale.vue?vue&type=style&index=0&id=63471c30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63471c30",
  null
  
)

export default component.exports